import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import _ from 'lodash';

import { ApiService } from 'src/services/api.service';

@Component({
  selector: 'app-display-inbound-app-chat',
  templateUrl: './display-inbound-app-chat.component.html',
  styleUrls: ['./display-inbound-app-chat.component.scss'],
})
export class DisplayInboundAppChatComponent implements OnInit {
  isLoading = false;

  inboundWidgetMessageId: string;
  inboundWidgetMessage: any;
  conversation: any;
  downloadFileId?: string;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private navController: NavController,
  ) {}

  async ngOnInit() {
    this.inboundWidgetMessageId = this.route.snapshot.paramMap.get('inboundAppChatId');
    this.downloadFileId = this.route.snapshot.queryParamMap.get('downloadFileId');

    if (this.downloadFileId) {
      await this.downloadAttachment(this.downloadFileId);
    }

    await this.fetchInboundAppChat();
  }

  async fetchInboundAppChat() {
    const inboundWidgetMessage: any = await this.apiService.getPromise(
      `/inbound-widget-messages/${this.inboundWidgetMessageId}`,
    );

    this.inboundWidgetMessage = inboundWidgetMessage;
    this.conversation = inboundWidgetMessage.inbound?.slackMessage?.ticket;
  }

  dismiss() {
    if (this.conversation) {
      this.navController.navigateForward(`dashboard/inbox/${this.conversation.id}`);
    } else {
      this.navController.pop();
    }
  }

  async downloadAttachment(attachmentId: string) {
    const response: any = await this.apiService.download(`/slack/files/${attachmentId}/download`, 'GET');

    const contentDisposition: string = response.headers.get('content-disposition');
    const filename =
      contentDisposition
        .split(';')
        .find((p) => p.startsWith('filename'))
        ?.split('=')[1] ?? 'file.txt';

    const binaryData = [];

    binaryData.push(response.body);

    const downloadLink = document.createElement('a');

    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
    downloadLink.setAttribute('download', filename);

    document.body.appendChild(downloadLink);

    downloadLink.click();
    downloadLink.remove();
  }
}
